import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import styled, { css } from "styled-components";
import Text from "../../Text";
import Heading, { StyledHeading } from "../../Heading";
import defaultTheme from "../../defaultTheme";
import media from "../../utils/mediaQuery";
import { StyledModalSection } from "../ModalSection";
import { left, right, rtlSpacing } from "../../utils/rtl";
import { withModalContext } from "../ModalContext";
var ModalTitle = styled.div.withConfig({
  displayName: "ModalHeader__ModalTitle",
  componentId: "sc-13vyf6i-0"
})(["margin-top:", ";", "{padding-", ":", ";}", ";"], function (_ref) {
  var theme = _ref.theme,
      illustration = _ref.illustration;
  return illustration && theme.orbit.spaceXSmall;
}, StyledHeading, right, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.spaceXLarge;
}, media.desktop(css(["", "{padding:0;}"], StyledHeading)));
ModalTitle.defaultProps = {
  theme: defaultTheme
};
var ModalDescription = styled.div.withConfig({
  displayName: "ModalHeader__ModalDescription",
  componentId: "sc-13vyf6i-1"
})(["margin-top:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.spaceXSmall;
});
ModalDescription.defaultProps = {
  theme: defaultTheme
};
export var StyledModalHeader = styled.div.withConfig({
  displayName: "ModalHeader__StyledModalHeader",
  componentId: "sc-13vyf6i-2"
})(["width:100%;display:block;padding:", ";border-top-left-radius:", ";border-top-right-radius:", ";box-sizing:border-box;background-color:", ";& ~ ", ":first-of-type{border-top:", ";border-top-left-radius:0;border-top-right-radius:0;margin-top:", ";}", ";"], function (_ref4) {
  var theme = _ref4.theme,
      illustration = _ref4.illustration,
      suppressed = _ref4.suppressed;
  return rtlSpacing(illustration && suppressed && "".concat(theme.orbit.spaceXLarge, " ").concat(theme.orbit.spaceMedium, " ").concat(theme.orbit.spaceLarge, " ").concat(theme.orbit.spaceMedium) || illustration && !suppressed && "".concat(theme.orbit.spaceXLarge, " ").concat(theme.orbit.spaceMedium, " 0 ").concat(theme.orbit.spaceMedium) || !illustration && suppressed && "".concat(theme.orbit.spaceLarge, " ").concat(theme.orbit.spaceMedium, " ").concat(theme.orbit.spaceLarge, " ").concat(theme.orbit.spaceMedium) || "".concat(theme.orbit.spaceLarge, " ").concat(theme.orbit.spaceMedium, " 0 ").concat(theme.orbit.spaceMedium));
}, function (_ref5) {
  var isMobileFullPage = _ref5.isMobileFullPage;
  return !isMobileFullPage && "9px";
}, function (_ref6) {
  var isMobileFullPage = _ref6.isMobileFullPage;
  return !isMobileFullPage && "9px";
}, function (_ref7) {
  var suppressed = _ref7.suppressed,
      theme = _ref7.theme;
  return suppressed ? theme.orbit.paletteCloudLight : theme.orbit.paletteWhite;
}, StyledModalSection, function (_ref8) {
  var suppressed = _ref8.suppressed,
      theme = _ref8.theme;
  return suppressed && "1px solid ".concat(theme.orbit.paletteCloudNormal);
}, function (_ref9) {
  var suppressed = _ref9.suppressed;
  return suppressed && "0!important";
}, media.largeMobile(css(["padding:", ";& ~ ", ":first-of-type{border-top-left-radius:0;border-top-right-radius:0;}"], function (_ref10) {
  var theme = _ref10.theme,
      illustration = _ref10.illustration,
      suppressed = _ref10.suppressed;
  return rtlSpacing(illustration ? "".concat(theme.orbit.spaceXLarge, " ").concat(theme.orbit.spaceXXLarge, " ").concat(suppressed ? theme.orbit.spaceXXLarge : "0", " ").concat(theme.orbit.spaceXXLarge) : "".concat(theme.orbit.spaceXXLarge, " ").concat(theme.orbit.spaceXXLarge, " ").concat(suppressed ? theme.orbit.spaceXXLarge : "0", " ").concat(theme.orbit.spaceXXLarge));
}, StyledModalSection)));
StyledModalHeader.defaultProps = {
  theme: defaultTheme
};
export var MobileHeader = styled.div.withConfig({
  displayName: "ModalHeader__MobileHeader",
  componentId: "sc-13vyf6i-3"
})(["display:inline-block;position:fixed;visibility:hidden;height:52px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;top:", ";", ":48px;", ":0;font-family:", ";font-weight:", ";font-size:18px;color:", ";line-height:52px;box-sizing:border-box;padding:", ";opacity:0;transition:top ", " ease-in-out,opacity ", " ease-in-out,visibility ", " ease-in-out;z-index:800;", ";"], function (_ref11) {
  var isMobileFullPage = _ref11.isMobileFullPage;
  return isMobileFullPage ? "0" : "16px";
}, right, left, function (_ref12) {
  var theme = _ref12.theme;
  return theme.orbit.fontFamily;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.orbit.fontWeightHeadingDisplay;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.orbit.colorHeading;
}, function (_ref15) {
  var theme = _ref15.theme;
  return rtlSpacing("0 0 0 ".concat(theme.orbit.spaceLarge));
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.orbit.durationFast;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.orbit.durationFast;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.orbit.durationFast;
}, media.largeMobile(css(["left:auto;right:auto;padding:0;"])));
MobileHeader.defaultProps = {
  theme: defaultTheme
};
var StyledModalHeaderContent = styled.div.withConfig({
  displayName: "ModalHeader__StyledModalHeaderContent",
  componentId: "sc-13vyf6i-4"
})(["margin-top:", ";"], function (_ref19) {
  var description = _ref19.description;
  return description ? "32px" : "16px";
});

var ModalHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ModalHeader, _React$PureComponent);

  function ModalHeader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "callContextFunctions", function () {
      var _this$props = _this.props,
          setDimensions = _this$props.setDimensions,
          decideFixedFooter = _this$props.decideFixedFooter;

      if (setDimensions) {
        setDimensions();
      }

      if (decideFixedFooter) {
        decideFixedFooter();
      }
    });

    return _this;
  }

  _createClass(ModalHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.callContextFunctions();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        this.callContextFunctions();
        var manageFocus = this.props.manageFocus;

        if (manageFocus) {
          manageFocus();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          illustration = _this$props2.illustration,
          description = _this$props2.description,
          children = _this$props2.children,
          suppressed = _this$props2.suppressed,
          dataTest = _this$props2.dataTest,
          isMobileFullPage = _this$props2.isMobileFullPage;
      var hasHeader = title || description;
      return React.createElement(StyledModalHeader, {
        illustration: !!illustration,
        suppressed: suppressed,
        "data-test": dataTest,
        isMobileFullPage: isMobileFullPage
      }, illustration, hasHeader && React.createElement(ModalTitle, {
        illustration: !!illustration
      }, title && React.createElement(Heading, {
        type: "title1"
      }, title), description && React.createElement(ModalDescription, null, React.createElement(Text, {
        size: "large",
        element: "div"
      }, description))), children && React.createElement(StyledModalHeaderContent, {
        description: !!description
      }, children), title && React.createElement(MobileHeader, {
        isMobileFullPage: isMobileFullPage
      }, title));
    }
  }]);

  return ModalHeader;
}(React.PureComponent);

var DecoratedComponent = withModalContext(ModalHeader); // $FlowFixMe flow doesn't recognize displayName for functions

DecoratedComponent.displayName = "ModalHeader";
export default DecoratedComponent;